import { useCallback, useEffect, useRef, useState } from 'react';
import { driver } from 'driver.js';
import type { Config, DriveStep, Driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { useTourStore } from '@/stores/tourStore';

interface UseGuidedTourOptions {
  tourId: string;
  steps: DriveStep[];
  config?: Partial<Config>;
}

export function useGuidedTour({ tourId, steps, config }: UseGuidedTourOptions) {
  const driverRef = useRef<Driver | null>(null);
  const [isActive, setIsActive] = useState(false);

  const start = useCallback(() => {
    driverRef.current = driver({
      steps,
      showProgress: true,
      popoverClass: 'aflow-tour',
      nextBtnText: 'Далее',
      prevBtnText: 'Назад',
      doneBtnText: 'Готово',
      progressText: '{{current}} из {{total}}',
      onDestroyed: () => {
        useTourStore.getState().markCompleted(tourId);
        setIsActive(false);
      },
      ...config,
    });
    setIsActive(true);
    driverRef.current.drive();
  }, [tourId, steps, config]);

  const stop = useCallback(() => {
    driverRef.current?.destroy();
  }, []);

  useEffect(() => {
    return () => {
      driverRef.current?.destroy();
    };
  }, []);

  return { start, stop, isActive };
}
